import { priorityInboxThreadInvalidations } from "@circle-react/lib/queries/priorityInboxThreads";
import { useMemo } from "react";
import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { reactQueryPatch } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

import { useUnreadChatRoomsStore } from "./store";
import { useUnreadChatRoomUuids } from "./useUnreadChatRoomUuids";

export const useMarkAllChatRoomAsRead = () => {
  const { currentCommunitySettings, currentCommunity } = usePunditUserContext();
  const toast = useToast();

  const {
    cached_unread_chat_room_ids_enabled: isCachedUnreadChatRoomIdsEnabled,
  } = currentCommunitySettings || {};
  const communityId = Number(currentCommunity?.id);
  const { setUnreadChatRoomUuids } = useUnreadChatRoomsStore();
  const unreadChatRoomUuids = useUnreadChatRoomUuids({ communityId });

  const params = useMemo<Record<string, unknown>>(() => {
    const options: Record<string, unknown> = {};
    if (isCachedUnreadChatRoomIdsEnabled) {
      options["only_unread"] = true;
    } else {
      options["uuids"] = unreadChatRoomUuids;
    }
    return options;
  }, [isCachedUnreadChatRoomIdsEnabled, unreadChatRoomUuids]);

  const { mutateAsync: markAllChatRoomAsRead, isPending: isLoading } =
    useMutation({
      mutationFn: () =>
        reactQueryPatch(
          internalApi.chatRooms.markAllAsRead({
            params,
          }),
        ),
      onSuccess: () => {
        setUnreadChatRoomUuids(communityId, []);
        void priorityInboxThreadInvalidations.all();
        toast.success(t("header_v3.chats_marked_as_read"));
      },
    });

  return { markAllChatRoomAsRead, isLoading };
};
